export default __webpack_public_path__ + "static/media/451.32523c66.png";